/* <upsell-card> — checkboxes are pending add-ons for the main PDP add-to-cart.
   They do not mutate the cart by themselves; ProductForm reads the checked cards
   and submits them with the selected product in one cart/add.js request. */
;(function () {
  'use strict';

  var CHANGE_EVENT = 'theme:upsells:change';

  function rootFor(el) {
    return el && el.closest ? (el.closest('[product-info]') || document) : document;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    return String(cents);
  }

  function parseMoney(value) {
    var amount = Number(value);
    return Number.isFinite(amount) ? amount : 0;
  }

  function selectedForProduct(root) {
    root = root || document;
    return Array.prototype.slice.call(root.querySelectorAll('upsell-card input[type="checkbox"]:checked'))
      .map(function (input) {
        var card = input.closest('upsell-card');
        return {
          id: Number(card.getAttribute('data-variant-id')),
          quantity: 1,
          price: Number(card.getAttribute('data-price')) || 0,
          title: card.getAttribute('data-title') || ''
        };
      })
      .filter(function (item) { return item.id; });
  }

  function updateProductCta(root) {
    root = root || document;
    var button = root.querySelector('product-form [name="add"][data-show-price="true"]');
    if (!button || button.disabled) return;

    var text = button.querySelector('.btn--text');
    if (!text) return;

    var basePrice = Number(button.getAttribute('data-base-price')) || 0;
    var label = button.getAttribute('data-add-label') || text.textContent.trim();
    var addons = selectedForProduct(root);
    var addonTotal = addons.reduce(function (total, item) { return total + item.price; }, 0);

    text.textContent = label + ' · ' + formatMoney(basePrice + addonTotal);
  }

  window.DigitdeckUpsells = {
    selectedForProduct: selectedForProduct,
    updateProductCta: updateProductCta
  };

  if (!window.customElements.get('upsell-card')) {
    class UpsellCard extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.checkbox = this.querySelector('input[type="checkbox"]');
        if (!this.checkbox) return;

        this.sync();
        this.variantButtons = this.querySelectorAll('[data-upsell-variant-id]');
        this.thumb = this.querySelector('.fbt-card__thumb');
        this.priceText = this.querySelector('[data-upsell-price-text]');
        this.compareText = this.querySelector('[data-upsell-compare-price-text]');
        this.titleText = this.querySelector('[data-upsell-title-text]');
        this.variantButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.applyVariant(button, true);
          });
        });
        if (this.variantButtons.length) {
          var activeButton = Array.prototype.find.call(this.variantButtons, function (button) {
            return button.classList.contains('is-active');
          }) || this.variantButtons[0];
          this.applyVariant(activeButton, false);
        }
        this.checkbox.addEventListener('change', () => {
          this.sync();
          this.dispatchChange();
        });
        this.addEventListener('click', (event) => {
          if (event.target.closest('input, label, a, button')) return;
          this.checkbox.checked = !this.checkbox.checked;
          this.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      sync() {
        this.classList.toggle('is-checked', this.checkbox && this.checkbox.checked);
      }

      applyVariant(button, notify) {
        if (!button) return;
        this.variantButtons.forEach((item) => {
          var isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        var variantId = button.getAttribute('data-upsell-variant-id');
        var price = parseMoney(button.getAttribute('data-upsell-price'));
        var compareAt = parseMoney(button.getAttribute('data-upsell-compare-price'));
        var title = button.getAttribute('data-upsell-title') || '';
        var image = button.getAttribute('data-upsell-image');
        var imageAlt = button.getAttribute('data-upsell-image-alt') || title;

        this.setAttribute('data-variant-id', variantId || '');
        this.setAttribute('data-price', price);
        if (title) this.setAttribute('data-title', title);

        if (this.titleText && title) {
          this.titleText.textContent = title;
        }

        if (this.priceText) {
          this.priceText.textContent = formatMoney(price);
        }

        if (this.compareText) {
          if (compareAt > price) {
            this.compareText.textContent = formatMoney(compareAt);
            this.compareText.classList.remove('hidden');
          } else {
            this.compareText.textContent = '';
            this.compareText.classList.add('hidden');
          }
        }

        if (this.thumb && image && this.thumb.tagName === 'IMG') {
          this.thumb.src = image;
          this.thumb.alt = imageAlt;
        }

        if (this.checkbox) {
          this.checkbox.setAttribute('aria-label', 'Agregar ' + (title || this.getAttribute('data-title') || '') + ' al pedido');
        }

        if (notify) {
          this.dispatchChange();
        }
      }

      dispatchChange() {
        var detail = { selected: selectedForProduct(rootFor(this)) };
        if (window.HELPER_UTIL && typeof HELPER_UTIL.dispatchCustomEvent === 'function') {
          HELPER_UTIL.dispatchCustomEvent(CHANGE_EVENT, this, detail);
        } else {
          this.dispatchEvent(new CustomEvent(CHANGE_EVENT, { bubbles: true, detail: detail }));
        }
      }
    }
    window.customElements.define('upsell-card', UpsellCard);
  }

  document.addEventListener(CHANGE_EVENT, function (event) {
    updateProductCta(rootFor(event.target));
  });

  document.addEventListener('theme:variant:change', function (event) {
    var root = rootFor(event.target);
    var button = root.querySelector('product-form [name="add"]');
    if (button && event.detail && event.detail.variant && event.detail.variant.price != null) {
      button.setAttribute('data-base-price', event.detail.variant.price);
    }
    updateProductCta(root);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[product-info]').forEach(function (root) {
      updateProductCta(root);
    });
  });
})();
